import React from 'react';
import { G, Line, Polygon, Rect } from 'react-native-svg';
import { DT } from '../tokens';

type Props = {
  x: number; y: number; width: number; height: number;
  /** Number of hatching lines across the filter face */
  hatchCount?: number;
  /** Show upstream (left) and downstream (right) flow arrows */
  showArrows?: boolean;
};

/** Filter face with hatching and optional upstream/downstream arrows. */
export function FilterFace({ x, y, width, height, hatchCount = 6, showArrows = true }: Props) {
  const hatches = Array.from({ length: hatchCount }, (_, i) => {
    const xPos = x + (width / (hatchCount + 1)) * (i + 1);
    return <Line key={i} x1={xPos} y1={y} x2={xPos} y2={y + height} stroke={DT.stroke} strokeWidth="1" opacity={0.6} />;
  });

  const cy = y + height / 2;
  const arrowOffset = 28;

  return (
    <G>
      <Rect x={x} y={y} width={width} height={height} fill={DT.fill} stroke={DT.stroke} strokeWidth="2" />
      {hatches}
      {showArrows && (
        <>
          {/* Upstream arrow → filter */}
          <Line x1={x - arrowOffset} y1={cy} x2={x - 4} y2={cy} stroke={DT.arrow} strokeWidth="1.5" />
          <Polygon points={`${x - 4},${cy} ${x - 10},${cy - 4} ${x - 10},${cy + 4}`} fill={DT.arrow} />
          {/* Downstream arrow ← filter */}
          <Line x1={x + width + 4} y1={cy} x2={x + width + arrowOffset} y2={cy} stroke={DT.arrow} strokeWidth="1.5" />
          <Polygon points={`${x + width + arrowOffset},${cy} ${x + width + arrowOffset - 6},${cy - 4} ${x + width + arrowOffset - 6},${cy + 4}`} fill={DT.arrow} />
        </>
      )}
    </G>
  );
}
